import React, { useEffect, useState } from "react";

// components
import { Row, Col, Spinner } from "reactstrap";

// style
import "assets/css/loading.css";

// api
import dashboard_api from "api/dashboard_api";
import setup_api from "api/setup_api";

//helpers
import { showMessage } from "helpers/message.js";
import useInterval from "helpers/interval.js";

import SetupVisualizacao from "./Components/SetupVisualizacao";
import PainelMapa from "./Components/PainelMapa";
import PainelGrafico from "./Components/PainelGrafico";

export default function Dashboard() {

  const [showLoading, set_showLoading] = useState(false);

  // const [grupoAnterior, set_grupoAnterior] = useState("");
  const [grupoEmExecucao, set_grupoEmExecucao] = useState(null);
  const [gruposExecutados, set_gruposExecutados] = useState([]);
  const [step, set_step] = useState(0);
  const [painel, set_painel] = useState({});
  const [setup, set_setup] = useState(null);

  useEffect(() => {
    loadSetup();
  }, []);
  const loadSetup = () => {
    set_showLoading(true);

    setup_api.getSetup().then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else if (result.data == null || result.data.length == 0) {
        showMessage("Aviso", "Não existem dados para serem carregados.", 'warning', null);
      }
      else {
        let _groupIsOpen = [];
        result.data.grupos.map((item, key) => {
          let _group = {
            groupName: item,
            isOpen: true
          };
          _groupIsOpen.push(_group);
        });

        setgroupIsOpen(_groupIsOpen);

        let _painelsChecked = [];

        result.data.painels.map((painel => {
          if (painel != null) {
            let _painel = {
              groupName: painel.grupo,
              painelName: painel.titulo,
              isChecked: true
            };
            _painelsChecked.push(_painel);
          }
        }));

        setpainelsChecked(_painelsChecked);

        set_setup(result.data);
      }
    });

    set_showLoading(false);
  }
  useEffect(() => {
    if (setup != null && groupIsOpen.length > 0) {
      NextPainel();
    }
  }, [setup]);

  const loadGrupoPainel = (grupo) => {
    const promise = new Promise((resolve, reject) => {
      set_showLoading(true);
      dashboard_api.getDashboardByGroup(grupo).then(result => {
        set_showLoading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
          resolve(result.data);
        }
        else {
          resolve(result.data);
        }
      });
    });

    return promise;
  }

  const verifyGruposPendentes = () => {
    return groupIsOpen.filter(x => x.isOpen == true && !gruposExecutados.filter(y => y == x.groupName).length);
  }
  const reloadSetupGrupos = () => {
    set_grupoEmExecucao(null);
    set_step(0);
    set_gruposExecutados([]);
  }

  // variáveis de controle do clock
  const [delay, set_delay] = useState(12000);
  const [isPlaying, set_isPlaying] = useState(false);
  useInterval(() => {
    NextPainel();
  }, isPlaying ? delay : null)

  const NextPainel = () => {
    let gruposPendentes = verifyGruposPendentes();

    if (gruposPendentes.length > 0) {
      let _grupo = gruposPendentes[0].groupName;
      let _grupoEmExecucao = grupoEmExecucao;
      let _step = step + 1;
      let _totalSteps = painelsChecked.filter(x => x.groupName == _grupo && x.isChecked == true).length;

      if (_grupoEmExecucao == null || grupoEmExecucao.painels[0].grupo == _grupo) {
        if (_grupoEmExecucao == null) {
          carregaGrupo(_grupo, _step, _totalSteps);
        }
        else if (step != 0 && _step > _totalSteps) {
          finalizaGrupo(_grupoEmExecucao.painels[0].grupo);
        }
        else {
          loadStep(_grupoEmExecucao, _step, _totalSteps);
        }
      }
      else {
        finalizaGrupo(grupoEmExecucao.painels[0].grupo);
      }
    }
    else {
      reloadSetupGrupos();
    }
  }

  const carregaGrupo = (grupo, _step, _totalSteps) => {
    loadGrupoPainel(grupo).then(_grupoPainel => {
      if (_grupoPainel != null) {
        set_grupoEmExecucao(_grupoPainel);
        _totalSteps = painelsChecked.filter(x => x.groupName == grupo && x.isChecked == true).length;
        loadStep(_grupoPainel, _step, _totalSteps);
      }
      else {
        return;
      }
    });
  }

  const loadStep = (_grupoEmExecucao, _step, _totalSteps) => {
    set_showLoading(true);
    if (_step != 0 && _step <= _totalSteps) {
      let _nextPainel = _grupoEmExecucao.painels[_step - 1];
      let _exibirPainel = painelsChecked.filter(x => x.groupName == _nextPainel.grupo && x.painelName == _nextPainel.titulo);

      if (_exibirPainel.length > 0 && _exibirPainel[0].isChecked) {
        if (_nextPainel.tipo == "Mapa")
          loadCenterMap(_nextPainel.mapa.markers);

        set_painel(_nextPainel);
        console.log(_nextPainel);
        set_step(_step);
      }
      else {
        _step = _step + 1;
      }
    }
    set_showLoading(false);
  }

  const finalizaGrupo = (_grupo) => {
    gruposExecutados.push(_grupo);
    set_grupoEmExecucao(null);
    set_step(0);
  }

  // variáveis de controle das propriedades do mapa
  const [zoomMap, set_zoomMap] = useState(11);
  const [centerMap, set_centeMap] = useState([-23.547241, -46.637407]);
  const loadCenterMap = (_markers) => {
    if (step == 0 || (_markers == null || _markers.length == 0)) {
      set_centeMap([-23.547241, -46.637407]);
      set_zoomMap(11);
    }
    else {
      set_centeMap([_markers[0].lat, _markers[0].lng]);
      set_zoomMap(12);
    }
  }

  // Ações
  const [showPlay, set_ShowPlay] = useState(true);
  const handleBackward = () => {
    let _step = step - 1;
    let gruposOpen = groupIsOpen.filter(x => x.isOpen == true);

    if (grupoEmExecucao == null)
      return;
    else if (_step < 0) {
      let _indexGrupoEmExecucao = gruposOpen.map(function (e) { return e.groupName; }).indexOf(grupoEmExecucao.painels[0].grupo);
      let _grupoAnterior = "";
      if (_indexGrupoEmExecucao == 0)
        _grupoAnterior = gruposOpen[0].groupName;
      else
        _grupoAnterior = gruposOpen[_indexGrupoEmExecucao - 1].groupName;

      let _newGruposExecutados = gruposExecutados.filter(x => x != _grupoAnterior);
      set_gruposExecutados(_newGruposExecutados);
      set_step(0);
      set_grupoEmExecucao(null);
      carregaGrupo(_grupoAnterior, 1, 0);
      return;
    }
    else {
      set_step(_step);
      let _totalSteps = painelsChecked.filter(x => x.groupName == grupoEmExecucao.painels[0].grupo && x.isChecked == true).length;
      loadStep(grupoEmExecucao, _step, _totalSteps);
    }
  }

  const handlePauseMap = () => {
    pauseInterval();
  }
  const pauseInterval = () => {
    set_ShowPlay(true);
    set_isPlaying(false);
  }

  const handlePlayMap = () => {
    set_ShowPlay(false);
    set_isPlaying(true);
  }

  const handleForward = () => {
    NextPainel();
  }

  // Modal Setup
  const [modal, setModal] = useState(false);
  const [groupIsOpen, setgroupIsOpen] = useState([]);
  const [painelsChecked, setpainelsChecked] = useState([]);
  const toggleModalSetup = () => {
    setModal(!modal);

    if (!modal) {
      pauseInterval();
    }
  }

  const handleChangeGrupo = (checked, grupo) => {
    let vefifyExists = groupIsOpen.filter(x => x.groupName === grupo)[0];
    vefifyExists.isOpen = checked;

    let updateList = groupIsOpen.map(l => (l.groupName === grupo ? vefifyExists : l));
    setgroupIsOpen(updateList);
  }

  const handleChangePainel = (checked, group, painel) => {
    let vefifyExists = painelsChecked.filter(x => x.groupName == group && x.painelName == painel)[0];
    vefifyExists.isChecked = checked;

    let updateList = painelsChecked.map(l => (l.groupName == group && l.painelName === painel ? vefifyExists : l));
    setpainelsChecked(updateList);
  }

  const handleConfirmaSetup = () => {
    setModal(!modal);
    handlePlayMap();
  }

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className="content" height="max-content">
        <Row>
          <Col lg="12" md="12" sm="12" xs="12">
            {(painel && painel.tipo == "Mapa") &&
              <PainelMapa
                showLoading={showLoading}
                painel={painel}
                centerMap={centerMap}
                zoomMap={zoomMap}
                showPlay={showPlay}
                toggleModalSetup={toggleModalSetup}
                handleBackward={handleBackward}
                handlePauseMap={handlePauseMap}
                handlePlayMap={handlePlayMap}
                handleForward={handleForward}
              />
            }
            {(painel && painel.tipo == "Gráfico") &&
              <PainelGrafico
                showLoading={showLoading}
                painel={painel}
                showPlay={showPlay}
                toggleModalSetup={toggleModalSetup}
                handleBackward={handleBackward}
                handlePauseMap={handlePauseMap}
                handlePlayMap={handlePlayMap}
                handleForward={handleForward}
              />
            }
          </Col>
        </Row>
      </div>
      <SetupVisualizacao
        modal={modal}
        toggleModalSetup={toggleModalSetup}
        setup={setup}
        groupIsOpen={groupIsOpen}
        painelsChecked={painelsChecked}
        handleChangeGrupo={handleChangeGrupo}
        handleChangePainel={handleChangePainel}
        handleConfirmaSetup={handleConfirmaSetup}
      />
    </>
  );
}

